import React from 'react'
import { NavLink, Switch, Redirect, Route } from 'react-router-dom'
import PropTypes from 'prop-types'

import { FeedbackGrid } from './FeedbackGrid'
import { PopupBox } from './PopupBox'
import CSATWidgetContainer from '../../../organisms/CSATWidget/container'

const Testimonials = ({ companyKey }) => (
  <div>
    <div className="admin-heading">
      <div className="grid ui stackable">
        <div className="eight wide column">
          <h2>Publish Feedback as Testimonials</h2>
        </div>
        <div className="eight wide column right aligned bottom">
          <p>
            <a
              href="https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings"
              target="_blank"
              rel="noreferrer"
              style={{ fontSize: 16 }}
            >
              <i className="icon far fa-book" />
              Learn more about publishing testimonials
            </a>
          </p>
        </div>
      </div>
    </div>
    <div className="grid ui stackable">
      <div className="four wide column">
        <div className="ui vertical text menu">
          <NavLink to="/settings/testimonials/feedback-grid/" className="item">
            Feedback Grid
          </NavLink>
          <NavLink to="/settings/testimonials/popup-box/" className="item">
            Popup Box
          </NavLink>
          <NavLink to="/settings/testimonials/csat-widget/" className="item">
            CSAT Widget
          </NavLink>
        </div>
      </div>
      <div className="twelve wide column">
        <Switch>
          <Redirect
            from="/settings/testimonials/"
            exact
            to="/settings/testimonials/feedback-grid/"
          />
          <Route
            path="/settings/testimonials/feedback-grid/"
            render={() => <FeedbackGrid companyKey={companyKey} />}
          />
          <Route
            path="/settings/testimonials/popup-box/"
            render={() => <PopupBox basic companyKey={companyKey} />}
          />
          <Route
            path="/settings/testimonials/csat-widget/"
            render={() => <CSATWidgetContainer companyKey={companyKey} />}
          />
        </Switch>
      </div>
    </div>
  </div>
)

Testimonials.propTypes = {
  companyKey: PropTypes.string,
}

export default Testimonials



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/TestimonialsLegacy/index.js